<template>
  <PageTemplate>
    <h1>Members</h1>
    <fieldset class="fieldset">
      <v-input-wrap prefix="search">
        <v-input
          type="search"
          @search="performSearchAction"
          @input="performSearch"
        />
      </v-input-wrap>
    </fieldset>

    <v-card title="Committee Members">
      <div class="row">
        <div
          v-for="member in members"
          :key="member.id"
          class="d-flex col-md-6 col-lg-4 col-xl-3"
        >
          <v-member
            :name="member.first_name + ' ' +member.last_name"
            :title="member.title || 'General'"
            :phone="member.mobile_number"
            :email="member.email"
          />
        </div>
      </div>
      <v-pagination
        v-if="!searchMode"
        :initial-current-page="page"
        :initial-rows-per-page="perPage"
        :count="total"
        :page-changed="pageChanged"
        :per-page-changed="perPageChanged"
      />
    </v-card>
  </PageTemplate>
</template>
<script>
import PageTemplate from "@/templates/Page/index.vue";
import { buildBreadCrumb } from "../common/tableFunctions";
import { GET_MEMBERS } from "../store/actions.type";
import Card from "@/molecules/Card";
import Member from "@/molecules/Member";
import Pagination from "@/molecules/Pagination";
import InputWithIcon from "@/molecules/InputWithIcon";
import Input from "@/atoms/Input";
import { mapState } from "vuex";
import routes from "@/common/routes";

export default {
  name: "Member",
  components: {
    "v-card": Card,
    "v-member": Member,
    "v-pagination": Pagination,
    "v-input": Input,
    "v-input-wrap": InputWithIcon,
    PageTemplate
  },
  data: () => ({
    searchKeyword: "",
    searchMode: false
  }),
  computed: {
    ...mapState({
      members: state => state.committees.currentMembers,
      selectedCommittee: state => state.auth.selectedCommittee,
      total: state => state.committees.total,
      page: state => state.committees.page,
      perPage: state => state.committees.perPage
    })
  },
  watch: {
    selectedCommittee: {
      handler(val, oldVal) {
        this.getMembers(val);
      }
    }
  },
  mounted() {
    this.updateBreadCrumb();
    this.getMembers(this.selectedCommittee);
  },
  methods: {
    updateBreadCrumb: function() {
      let breadcrumbs = [];
      breadcrumbs["Dashboard"] = routes.DASHBOARD;
      breadcrumbs["Members"] = "";
      this.breadcrumbs = buildBreadCrumb(breadcrumbs);
      this.$store.dispatch(
        "updateBreadCrumbAction",
        buildBreadCrumb(breadcrumbs)
      );
    },
    getMembers: function(id) {
      if (id !== null) {
        this.$store.dispatch(GET_MEMBERS, id);
      }
    },
    pageChanged: function(page) {
      if (page.currentPage > 0) {
        this.$store.dispatch("updateMemberPage", page.currentPage);
      }
    },
    perPageChanged: function(perPage) {
      if (perPage.currentPerPage > 0) {
        this.$store.dispatch("updateMemberPerPage", perPage.currentPerPage);
      }
    },
    performSearch: function(evt) {
      if (evt.length === 0) {
        this.searchMode = false;
        this.getMembers(this.selectedCommittee);
      } else {
        this.searchMembers(evt);
      }
    },
    performSearchAction: function(evt) {
      this.searchMembers(evt.target.value);
    },
    searchMembers: function(key) {
      this.searchKeyword = key.trim().replace(/\s+/g, " ");
      if (this.searchKeyword.length > 0) {
        this.searchMode = true;
        let res = this.$store.state.committees.members.filter(ele => {
          let str = [
            ele.first_name,
            ele.last_name,
            ele.title,
            ele.mobile_number,
            ele.email
          ];
          return this.searchKeyword.split(" ").some(
            r =>
              str
                .join()
                .toLowerCase()
                .indexOf(r.toLowerCase()) != -1
          );
        });
        this.$store.state.committees.currentMembers = res;
      } else {
        this.searchMode = false;
        this.getMembers(this.selectedCommittee);
      }
    }
  }
};
</script>

